
import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator';
import DateRange from '@/components/DateRange.vue';
import ProductPicker from '@/components/ProductPicker.vue';
import Util from '@/utils/util';
import api from '@/api';

const invitationCodeApi = api.invitationCode;

@Component({
  components: { DateRange, ProductPicker },
})
export default class InvitationCodeForm extends Vue {
  @Prop({ default: true }) private codeEditable!: boolean;

  @Prop({}) private invitationCode!: string;

  @Prop({}) private name!: string;

  @Prop({}) private authStatus!: number;

  @Prop({}) private point!: number;

  @Prop({}) private invitationGifts!: Array<{
    merchantId: number;
    productId: string;
  }>;

  @Prop({ default: true }) private isEnabled!: boolean;

  @Prop({}) private startOn!: string;

  @Prop({}) private endOn!: string;

  @Prop({ default: false }) private loading!: boolean;

  private valid: boolean = false;

  private invitationCodeErrorMessage: string = '';

  private form = {
    invitationCode: this.invitationCode,
    name: this.name,
    authStatus: this.authStatus,
    point: this.point || 0,
    invitationGifts: this.invitationGifts,
    isEnabled: this.isEnabled,
    startOn: this.startOn,
    endOn: this.endOn,
  };

  private rules = {
    invitationCode: [
      this.requiredRule('推薦代碼'),
      this.maxLengthRule('推薦代碼', 20),
      this.checkCodeExists(),
    ],
    name: [this.requiredRule('贈點明細'), this.maxLengthRule('贈點明細', 50)],
    authStatus: [this.requiredRule('贈送時機點')],
    startOn: [
      this.requiredRule('生效日期'),
      this.lessThenRule(
        '生效日期',
        '失效日期',
        (vm: InvitationCodeForm) => vm.form.endOn,
      ),
    ],
    endOn: [
      this.requiredRule('失效日期'),
      this.greaterThenRule(
        '失效日期',
        '生效日期',
        (vm: InvitationCodeForm) => vm.form.startOn,
      ),
    ],
  };

  private get inputs() {
    return {
      invitationCode: this.invitationCode,
      name: this.name,
      authStatus: this.authStatus,
      point: this.point || 0,
      invitationGifts: this.invitationGifts || [],
      isEnabled: this.isEnabled,
      startOn: this.startOn,
      endOn: this.endOn,
    };
  }

  private get datePeriod() {
    return {
      startOn: this.form.startOn,
      endOn: this.form.endOn,
    };
  }

  @Watch('inputs', { immediate: true })
  private inputsWatcher(val: any) {
    this.form = {
      ...val,
    };
  }

  @Watch('datePeriod')
  private datePeriodWatcher(val: any) {
    const inputs: any[] = (this.$refs.form as any).inputs.filter(
      (i: any) => i.label === '生效日期' || i.label === '失效日期',
    );
    inputs.forEach((input) => {
      input.validate(true);
    });
  }

  private requiredRule(column: string) {
    return (v: any) => !Util.isNullOrEmpty(v) || `${column} 為必填`;
  }

  private maxLengthRule(column: string, length: number) {
    return (v: any) => v?.length <= length || `${column} 最多 ${length} 字`;
  }

  private lessThenRule(
    column: string,
    column2: string,
    func: (vm: InvitationCodeForm) => any,
  ) {
    return (v: any) => {
      const c = func(this);
      return !v || !c || v <= c || `${column}要小於${column2}`;
    };
  }

  private greaterThenRule(
    column: string,
    column2: string,
    func: (vm: InvitationCodeForm) => any,
  ) {
    return (v: any) => {
      const c = func(this);
      return !v || !c || v >= c || `${column}要大於${column2}`;
    };
  }

  private checkCodeExists() {
    return (v: any) => {
      if (!v) return true;
      invitationCodeApi
        .get(v, { allowNotFound: true })
        .then((resp: { data: any }) => {
          this.invitationCodeErrorMessage = resp.data ? '優惠代碼存在' : '';
        });

      return true;
    };
  }

  private async cancel() {
    await this.$router.back();
  }

  @Emit()
  private submit() {
    const form = this.$refs.form as any as { validate: () => boolean };

    if (form.validate()) {
      const invitationGifts = this.form.invitationGifts.map((m) => m.productId);
      return {
        ...this.form,
        point: +this.form.point,
        invitationGifts,
      };
    }
    return null;
  }
}
